const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/onboarding/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/onboarding/")({
  beforeLoad: () => {
    redirect({
      to: settingsNavPathV3.members.onboarding,
      replace: true,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});